import { customerFields } from '@pylot-data/core-queries/customer'
export const CREATE_CUSTOMER = /* GraphQL */ `
    mutation createCustomer($input: CustomerCreateInput!) {
        createCustomerV2(input: $input) {
            customer {
                ${customerFields}
            }
        }
    }
`
